import React from 'react';
import clsx from 'clsx';

/**
 * SectionHeader — canonical section heading with optional subtitle, count badge, and action slot.
 * REQ-COMP-06 (Iteration 16 Component Unification Contract)
 */
export function SectionHeader({ title, subtitle, action, count, className }) {
  return (
    <div
      data-portica-role="section-header"
      className={clsx('flex items-center justify-between gap-3 mb-4', className)}
    >
      <div className="min-w-0">
        <div className="flex items-center gap-2">
          <h3
            className="text-base font-semibold truncate"
            style={{ font: 'var(--text-h3)', color: 'var(--color-text-default)' }}
          >
            {title}
          </h3>
          {count != null && (
            <span
              className="inline-flex items-center justify-center px-2 py-0.5 text-xs font-medium rounded-full"
              style={{
                backgroundColor: 'var(--color-surface-sunken)',
                color: 'var(--color-text-secondary)',
              }}
            >
              {count}
            </span>
          )}
        </div>
        {subtitle && (
          <p className="text-sm mt-0.5" style={{ color: 'var(--color-text-secondary)' }}>
            {subtitle}
          </p>
        )}
      </div>
      {action && <div className="flex-shrink-0">{action}</div>}
    </div>
  );
}

export default SectionHeader;
